import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white mt-24 md:mt-32">
      <div className="w-full mx-auto px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="bg-white rounded-lg p-1.5 flex items-center justify-center shrink-0">
                <img src="/fluenex-symbol.svg" alt="" aria-hidden="true" className="h-7 w-auto object-contain" />
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-display font-bold text-lg tracking-tight text-white">
                  Fluenex <span className="font-normal">Academy</span>
                </span>
                <span className="font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-lemon mt-1">
                  Proof over Paper
                </span>
              </div>
            </div>
            <h2 className="font-display font-bold tracking-tight text-4xl md:text-6xl leading-[1.02] max-w-2xl">
              Learn it from someone who has actually done it.
            </h2>
            <p className="font-serif italic text-xl md:text-2xl text-white/70 mt-6 max-w-xl">
              Every instructor built a career in the work first. Then they taught it.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="font-sans text-xs font-bold text-lemon mb-6 uppercase tracking-wide">
              Explore
            </p>
            <ul className="space-y-3 text-white/75">
              <li><Link to="/courses" className="hover:text-white transition-colors">Course Catalog</Link></li>
              <li><Link to="/workshops/intro-to-ethical-hacking" className="hover:text-white transition-colors">Free Workshop</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Sign In</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-sans text-xs font-bold text-lemon mb-6 uppercase tracking-wide">
              Fees
            </p>
            <p className="text-sm text-white/70 leading-relaxed">
              Every fee shown is a starting figure. The exact amount, batch dates and
              terms are confirmed in a real conversation after you enquire.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="font-sans text-[11px] font-semibold text-white/40">
            Education · Skill Training · BPO Services · Resources
          </p>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="font-sans text-[11px] font-semibold text-white/40 hover:text-white/70 transition-colors">
              Privacy Policy
            </Link>
            <p className="font-sans text-[11px] font-semibold text-white/40">
              © {new Date().getFullYear()} Fluenex Academy
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
